module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-SemiBold-838c5dc54f744ab3ec5844269f5b3c4c.woff2";